import "./ManageApiKeysPage.css";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { AppDispatch } from "../../redux/store";
import Header from "../../components/common/Header/Header";
import { fetchManageApiKeys } from "../../redux/actions/apiKeys.actions";
import { withDefaultType } from "./params";
import ManageApiKeysContainer from "./components/ManageApiKeysContainer";
import GenerateManageKeyModal from "./components/GenerateManageKeyModal";
import RevokeManageKeyModal from "./components/RevokeManageKeyModal";

const ManageApiKeysPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const searchParams = useSearchParams()[0];

  const [generateOpen, setGenerateOpen] = useState(false);
  const [revokeOpen, setRevokeOpen] = useState(false);
  const [keyToModify, setKeyToModify] = useState<any>(null);

  useEffect(() => {
    dispatch(fetchManageApiKeys(withDefaultType(searchParams)));
  }, [dispatch, searchParams]);

  return (
    <div className="page lp-page">
      <GenerateManageKeyModal open={generateOpen} setOpen={setGenerateOpen} object={keyToModify} />
      <RevokeManageKeyModal open={revokeOpen} setOpen={setRevokeOpen} object={keyToModify} />

      <Header header="Manage API Keys" />
      <main className="lp-main">
        <ManageApiKeysContainer
          setGenerateOpen={setGenerateOpen}
          setRevokeOpen={setRevokeOpen}
          setKeyToModify={setKeyToModify}
        />
      </main>
    </div>
  );
};

export default ManageApiKeysPage;
